export default __webpack_public_path__ + "static/media/about-us-2.0217ddd4.png";